import { combineReducers, createReducer } from '@reduxjs/toolkit';

import { havePreventedSearchChanged, waitingForAutocompleteChanged } from 'Core/actions/autocomplete';
import { fromPayload } from 'Core/reducers/common';

export default combineReducers({
  waitingForResponse: createReducer(false, (builder) =>
    builder.addCase(waitingForAutocompleteChanged, fromPayload),
  ),
  havePreventedSearch: createReducer(false, (builder) =>
    builder.addCase(havePreventedSearchChanged, fromPayload),
  ),
});
